export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.auth_token && user.user) {
        return { 'Authorization': 'Bearer ' + user.auth_token ,'OfficeId':user.user.currentOfficeId,'Access-Control-Allow-Origin':'*'};
    } else {
        return {};
    }
}

export function authHeaderwithJson() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.auth_token) {
        return { 
            'Authorization': 'Bearer ' + user.auth_token ,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin':'*'
        };
    } else {
        return {};
    }
}